// tomtoc — süreli indirim geri sayımı (F43)
class TomtocSayac extends HTMLElement {
  connectedCallback() {
    this.bitis = Number(this.dataset.bitis) * 1000;
    this.alan = this.querySelector('.tc-sayac__saat');
    this.guncelle();
    this.zamanlayici = setInterval(() => this.guncelle(), 1000);
  }
  disconnectedCallback() { clearInterval(this.zamanlayici); }
  guncelle() {
    const kalan = this.bitis - Date.now();
    if (kalan <= 0) { clearInterval(this.zamanlayici); this.remove(); return; }
    const s = Math.floor(kalan / 1000);
    const gun = Math.floor(s / 86400), saat = Math.floor((s % 86400) / 3600), dk = Math.floor((s % 3600) / 60), sn = s % 60;
    const ik = (n) => String(n).padStart(2, '0');
    this.alan.textContent = (gun > 0 ? gun + ' gün ' : '') + ik(saat) + ':' + ik(dk) + ':' + ik(sn);
  }
}
customElements.define('tomtoc-sayac', TomtocSayac);

/* F31 — 30 gün kutusu varyant değişiminde güncellenir (K-121) */
(function () {
  function kutuHtml(d) {
    if (d.d) {
      return '<div class="tc-fiyat30"><span class="tc-fiyat30__etiket">'
        + '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M8 3v9"/><path d="m4.5 8.5 3.5 3.5 3.5-3.5"/></svg>'
        + 'Son 30 günün en düşük fiyatı</span><span class="tc-fiyat30__satir">'
        + '<s class="tc-fiyat30__eski">' + d.r + '</s><strong class="tc-fiyat30__yeni">' + d.f + '</strong>'
        + (d.o >= 1 ? '<span class="tc-fiyat30__oran">%' + d.o + ' indirim</span>' : '') + '</span></div>';
    }
    if (d.i) return '<p class="tc-fiyat-referans">Son 30 günün en düşük fiyatı: <strong>' + d.r + '</strong></p>';
    return '';
  }
  function bagla(alan) {
    var kaynak = alan.parentElement && alan.parentElement.querySelector('.tc-fiyat-veri');
    if (!kaynak) return;
    var veri; try { veri = JSON.parse(kaynak.textContent); } catch (e) { return; }
    var form = alan.closest('.product-info') || document;
    var hedef = form.querySelector('form[data-type="add-to-cart-form"]') || document;
    (hedef === document ? document : hedef).addEventListener('variant:change', function (olay) {
      var v = olay.detail && olay.detail.variant;
      if (!v) { alan.innerHTML = ''; return; }
      var d = veri[String(v.id)];
      alan.innerHTML = d ? kutuHtml(d) : '';
    });
  }
  function kur() { document.querySelectorAll('[data-tc-fiyat]').forEach(bagla); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
})();

/* F14 / K-133 — taksit tablosu varyant değişiminde güncellenir */
(function () {
  function para(k) { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(k / 100) + ' TL'; }
  function ciz(kutu, fiyat) {
    var oranlar = (kutu.dataset.oranlar || '').split(';').map(function (s) { var p = s.split(':'); return p.length > 1 && p[1] !== '' ? [Number(p[0]), Number(p[1].replace(',', '.'))] : null; }).filter(Boolean);
    var satir = '<tr><td>Tek çekim</td><td>' + para(fiyat) + '</td><td>' + para(fiyat) + '</td></tr>';
    oranlar.forEach(function (o) {
      var toplam = Math.round(fiyat * (1 + o[1] / 100));
      satir += '<tr' + (o[1] === 0 ? ' class="tc-taksit__farksiz"' : '') + '><td>' + o[0] + ' taksit</td><td>' + para(Math.round(toplam / o[0])) + '</td><td>' + para(toplam) + '</td></tr>';
    });
    var govde = kutu.querySelector('[data-tc-taksit-govde]'); if (govde) govde.innerHTML = satir;
    var farksiz = oranlar.filter(function (o) { return o[1] === 0; }).pop();
    var aylik = kutu.querySelector('[data-tc-taksit-aylik]'); if (aylik && farksiz) aylik.textContent = para(Math.round(fiyat / farksiz[0]));
  }
  function kur() {
    document.querySelectorAll('[data-tc-taksit]').forEach(function (kutu) {
      var form = (kutu.closest('.product-info') || document).querySelector('form[data-type="add-to-cart-form"]');
      (form || document).addEventListener('variant:change', function (olay) {
        var v = olay.detail && olay.detail.variant;
        if (v) ciz(kutu, v.price);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
})();

/* S-107 / K-135 — ürün detayları: varyanta göre ölçü seti ve ürün kodu */
(function () {
  function kur() {
    document.querySelectorAll('[data-tc-detay]').forEach(function (kutu) {
      var harita = {};
      var kaynak = kutu.querySelector('[data-tc-detay-sku-harita]');
      if (kaynak) { try { harita = JSON.parse(kaynak.textContent); } catch (e) {} }
      document.addEventListener('variant:change', function (olay) {
        var v = olay.detail && olay.detail.variant;
        if (!v) return;
        var kod = kutu.querySelector('[data-tc-detay-sku]');
        if (kod && v.sku) kod.textContent = v.sku;
        var set = harita[v.sku];
        if (!set) return;
        kutu.querySelectorAll('[data-set]').forEach(function (el) { el.hidden = el.getAttribute('data-set') !== set; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
})();

/* K-136 — "Son stoklar" rozeti seçili varyanta göre (EOL varyant listesi tomtoc.son_stok) */
(function () {
  document.addEventListener('variant:change', function (olay) {
    var v = olay.detail && olay.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-tc-son-stok]').forEach(function (r) {
      // stoğu biten varyantta "Tükendi" zaten görünür; "Son stoklar" gösterilmez
      r.hidden = r.getAttribute('data-tc-son-stok').split(',').indexOf(v.sku) === -1 || !v.available;
    });
  });
})();

/* S-109 a / K-137 — sabit Sepete ekle çubuğu */
(function () {
  function model(baslik) {
    var m = baslik.match(/[A-Za-zÇĞİÖŞÜçğıöşü]+-[A-Z]{1,3}\d{2,3}[A-Z]?/);
    if (m) return m[0];
    m = baslik.match(/\b([A-Z]{1,2}\d{2,3})\b\s+([A-ZÇĞİÖŞÜ][a-zçğıöşü]+)?/);
    if (m) return m[1] + (m[2] && !/^(Laptop|Sling|Omuz|Sırt|Çanta|Kılıf|Aksesuar|Seyahat|Göğüs|Bel|El|Tote|Tablet|Pasaport)$/.test(m[2]) ? ' ' + m[2] : '');
    return baslik.split(' ').slice(0, 2).join(' ');
  }
  function litre(baslik) { var m = baslik.match(/(\d+(?:[.,]\d+)?(?:-\d+)?)\s?L\b/); return m ? m[1].replace('.', ',') + 'L' : ''; }
  function inc(u) { var m = (u || '').match(/^\d+(?:[.,]\d+)?"/); return m ? m[0] : ''; }
  function para(k) { return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(k / 100) + ' TL'; }
  function kur(cubuk) {
    var baslik = cubuk.dataset.baslik || '';
    var uI = +cubuk.dataset.uyumIdx, rI = +cubuk.dataset.renkIdx;
    var sabitBoy = cubuk.dataset.boy || litre(baslik);
    var ad = cubuk.querySelector('[data-tc-sabit-ad]'), uyum = cubuk.querySelector('[data-tc-sabit-uyum]');
    function metin(opts) {
      var u = uI > -1 ? opts[uI] : '', r = rI > -1 ? opts[rI] : '';
      var boy = sabitBoy || inc(u);
      ad.textContent = [model(baslik), boy, r].filter(Boolean).join(' · ');
      if (uyum) uyum.textContent = u || '';
    }
    var ilk = []; try { ilk = JSON.parse(cubuk.dataset.secenekler || '[]'); } catch (e) {}
    metin(ilk);
    if (!ad.textContent) ad.textContent = model(baslik) + (sabitBoy ? ' · ' + sabitBoy : '');
    document.addEventListener('variant:change', function (olay) {
      var v = olay.detail && olay.detail.variant;
      if (!v) return;
      metin(v.options || [v.option1, v.option2, v.option3]);
      cubuk.querySelectorAll('[data-tc-sabit-fiyat]').forEach(function (f) { f.textContent = para(v.price); });
      var src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
      if (src) cubuk.querySelector('[data-tc-sabit-gorsel]').src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      cubuk.querySelector('[data-tc-sabit-ekle]').hidden = !v.available;
      cubuk.querySelector('[data-tc-sabit-haber]').hidden = !!v.available;
    });
    cubuk.querySelector('[data-tc-sabit-haber]').addEventListener('click', function () {
      var b = document.querySelector('.email-me-button, [class*=bis-btn]');
      if (b) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { b.click(); }, 350); }
    });
    // Impact varyant yüklenince butonu yeniden çizer; izlenen öğe kopmasın diye her kaydırmada güncel, görünür butonu bul
    // (gizli hızlı-satın-alma kopyası da var). Buton ekranın üstünden çıkınca çubuk açılır.
    var bekliyor = false;
    function kontrol() {
      bekliyor = false;
      var hedef = [...document.querySelectorAll('.product-info__buy-buttons')].find(function (x) { return x.offsetParent !== null; });
      var acik = !!hedef && hedef.getBoundingClientRect().bottom < 0;
      if (acik === cubuk.classList.contains('is-acik')) return;
      cubuk.classList.toggle('is-acik', acik);
      cubuk.setAttribute('aria-hidden', acik ? 'false' : 'true');
      cubuk.querySelectorAll('a, button').forEach(function (x) { x.tabIndex = acik ? 0 : -1; });
    }
    window.addEventListener('scroll', function () { if (!bekliyor) { bekliyor = true; requestAnimationFrame(kontrol); } }, { passive: true });
    kontrol();
  }
  function basla() { document.querySelectorAll('[data-tc-sabit]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();

/* S-109 c / K-137 — tükenen varyantta stoktaki renk önerisi */
(function () {
  function kur(kutu) {
    var veri = []; try { veri = JSON.parse(kutu.querySelector('[data-tc-oneri-veri]').textContent); } catch (e) { return; }
    var rI = +kutu.dataset.renkIdx;
    function etiketBul(renk) {
      var picker = kutu.closest('.product-info') || document;
      return [...picker.querySelectorAll('variant-picker label, .variant-picker label')].find(function (l) {
        var t = (l.querySelector('.sr-only') || l).textContent.trim();
        return t === renk;
      });
    }
    function guncelle(id) {
      var v = veri.find(function (x) { return x.id === +id; });
      if (!v || v.a) { kutu.hidden = true; return; }
      var aday = veri.find(function (x) { return x.a && x.o.every(function (d, i) { return i === rI || d === v.o[i]; }); });
      if (!aday) { kutu.hidden = true; return; }
      var renk = aday.o[rI];
      kutu.querySelector('[data-tc-oneri-renk]').textContent = renk;
      kutu.querySelector('[data-tc-oneri-renk2]').textContent = renk;
      var et = etiketBul(renk);
      var nokta = kutu.querySelector('[data-tc-oneri-nokta]');
      var bg = et && getComputedStyle(et).getPropertyValue('--swatch-background');
      nokta.style.background = bg && bg.trim() ? bg : '#d6d6d2';
      var link = kutu.querySelector('[data-tc-oneri-link]');
      link.href = '?variant=' + aday.id;
      link.onclick = function (ev) { var e2 = etiketBul(renk); if (e2) { ev.preventDefault(); e2.click(); } };
      kutu.hidden = false;
    }
    guncelle(kutu.dataset.secili);
    document.addEventListener('variant:change', function (olay) { var v = olay.detail && olay.detail.variant; if (v) guncelle(v.id); });
  }
  function basla() { document.querySelectorAll('[data-tc-oneri]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();

/* S-109 e / K-137 — koleksiyon araç çubuğunda sıralama (filtreler korunur) */
document.addEventListener('change', function (e) {
  var s = e.target.closest && e.target.closest('[data-tc-sirala]');
  if (!s) return;
  var u = new URL(window.location.href);
  u.searchParams.set('sort_by', s.value);
  u.searchParams.delete('page');
  window.location.href = u.toString();
});

/* S-109 b / K-137 — Birlikte al: toplam, boy eşleme, tek istekte sepete ekleme */
(function () {
  var SAYI = ['', 'Sepete ekle', 'İkisini sepete ekle', 'Üçünü sepete ekle'];
  function para(k) { return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 }).format(k / 100) + ' TL'; }
  function kur(kutu) {
    var satirlar = [...kutu.querySelectorAll('[data-tc-b-satir]')];
    var uI = +kutu.dataset.uyumIdx, rI = +kutu.dataset.renkIdx;
    function hesapla() {
      var secili = satirlar.filter(function (s) { return s.hasAttribute('data-ana') || s.querySelector('[data-tc-b-sec]').checked; });
      var toplam = secili.reduce(function (t, s) { return t + (+s.dataset.fiyat); }, 0);
      kutu.querySelector('[data-tc-b-adet]').textContent = secili.length + ' ürün';
      kutu.querySelector('[data-tc-b-tutar]').textContent = para(toplam);
      kutu.querySelector('[data-tc-b-ekle]').textContent = SAYI[secili.length] || 'Sepete ekle';
    }
    kutu.addEventListener('change', hesapla);
    kutu.querySelectorAll('a.tc-birlikte__ad').forEach(function (a) { a.addEventListener('click', function (e) { e.stopPropagation(); }); });
    document.addEventListener('variant:change', function (olay) {
      var v = olay.detail && olay.detail.variant;
      if (!v) return;
      var ana = kutu.querySelector('[data-ana]');
      ana.dataset.varyant = v.id; ana.dataset.fiyat = v.price;
      ana.querySelector('[data-tc-b-fiyat]').textContent = para(v.price);
      var opts = v.options || [];
      var ad = ana.querySelector('[data-tc-b-ad]');
      if (rI > -1 && opts[rI]) ad.textContent = ad.textContent.replace(/ · [^·]+$/, '') + ' · ' + opts[rI];
      var src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
      if (src) ana.querySelector('[data-tc-b-gorsel]').src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      if (uI > -1) satirlar.forEach(function (s) {
        if (!s.dataset.harita) return;
        try { var h = JSON.parse(s.dataset.harita); var yeni = h[opts[uI]] || h['*']; if (yeni) s.dataset.varyant = yeni; } catch (e) {}
      });
      hesapla();
    });
    kutu.querySelector('[data-tc-b-ekle]').addEventListener('click', async function () {
      var btn = this, hata = kutu.querySelector('[data-tc-b-hata]');
      var items = satirlar.filter(function (s) { return s.hasAttribute('data-ana') || s.querySelector('[data-tc-b-sec]').checked; })
        .map(function (s) { return { id: +s.dataset.varyant, quantity: 1 }; });
      btn.setAttribute('aria-busy', 'true'); hata.hidden = true;
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      try {
        var r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname }) });
        var j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Sepete eklenemedi');
        var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
        cart.sections = j.sections;
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: j.items || [], cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      } catch (e) { hata.textContent = e.message; hata.hidden = false; }
      btn.removeAttribute('aria-busy');
    });
    hesapla();
  }
  function basla() { document.querySelectorAll('[data-tc-birlikte]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();

/* S-109 f / K-137 (+K-140 ürün sayfası) — yorum pop-up'ı: ilk kart 6 sn sonra, 6 sn görünür, arası 8 sn, en fazla 3, × ile o ziyarette kapanır */
(function () {
  var ILK = 6000, SURE = 6000, ARA = 8000, EN_COK = 3, ANAHTAR = 'tc-yp-kapali';
  function basla() {
    var kutu = document.querySelector('[data-tc-yp]');
    if (!kutu) return;
    try { if (sessionStorage.getItem(ANAHTAR)) return; } catch (e) {}
    var veri = []; try { veri = JSON.parse(document.querySelector('[data-tc-yp-veri]').textContent); } catch (e) { return; }
    if (!veri.length) return;
    for (var i = veri.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = veri[i]; veri[i] = veri[j]; veri[j] = t; }
    var sira = 0, zaman = null, kapandi = false;
    function goster() {
      if (kapandi || sira >= Math.min(EN_COK, veri.length)) return;
      var y = veri[sira++];
      kutu.querySelector('[data-tc-yp-ad]').textContent = y.a;
      kutu.querySelector('[data-tc-yp-metin]').textContent = '“' + y.m + '”';
      kutu.querySelector('[data-tc-yp-urun]').textContent = y.u;
      var g = kutu.querySelector('[data-tc-yp-gorsel]'); g.hidden = !y.g;
      var link = kutu.querySelector('[data-tc-yp-link]');
      link.href = '/products/' + y.h + '#shopify-product-reviews';
      link.dataset.h = y.h;
      var acildi = false;
      function ac() {
        if (acildi || kapandi) return; acildi = true;
        kutu.hidden = false;
        requestAnimationFrame(function () { kutu.classList.add('is-acik'); });
        zaman = setTimeout(kapat, SURE);
      }
      // görsel yüklenince aç (en fazla 1,5 sn bekle)
      if (y.g) { g.onload = ac; g.onerror = function () { g.hidden = true; ac(); }; g.src = y.g + '?width=128'; setTimeout(ac, 1500); } else ac();
    }
    function kapat() {
      {
        kutu.classList.remove('is-acik');
        zaman = setTimeout(function () { kutu.hidden = true; zaman = setTimeout(goster, ARA); }, 300);
      }
    }
    // ürün sayfasında kart aynı ürünün yorumlarına kaydırır
    kutu.querySelector('[data-tc-yp-link]').addEventListener('click', function (olay) {
      var burada = kutu.getAttribute('data-tc-yp-urun-sayfa');
      var bolum = document.querySelector('[id$="__tomtoc_yorumlar"]');
      if (burada && this.dataset.h === burada && bolum) { olay.preventDefault(); bolum.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    kutu.querySelector('[data-tc-yp-kapat]').addEventListener('click', function () {
      kapandi = true; clearTimeout(zaman); kutu.classList.remove('is-acik'); setTimeout(function () { kutu.hidden = true; }, 300);
      try { sessionStorage.setItem(ANAHTAR, '1'); } catch (e) {}
    });
    setTimeout(goster, ILK);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();

/* Pazaryeri yorum rozeti (K-139): Trendyol/Hepsiburada'dan aktarılan, orada satın alması doğrulanmış yorumlar.
   Judge.me bu yorumları doğrulanmış işaretlemediği için rozeti biz ekliyoruz; sayfalama ile gelen yorumlar da yakalanır. */
(function () {
  var veri = document.querySelector('[data-tc-pazaryeri]');
  if (!veri) return;
  var harita = {};
  try { harita = JSON.parse(veri.textContent) || {}; } catch (e) { return; }
  function isle() {
    document.querySelectorAll('.jdgm-rev[data-review-id]:not([data-tc-pz])').forEach(function (rev) {
      var kaynak = harita[rev.getAttribute('data-review-id')];
      rev.setAttribute('data-tc-pz', kaynak || '');
      if (!kaynak) return;
      var yer = rev.querySelector('.jdgm-rev__author-wrapper') || rev.querySelector('.jdgm-rev__header');
      if (!yer) return;
      var r = document.createElement('span');
      r.className = 'tc-pz-rozet';
      r.textContent = '✓ Doğrulanmış alışveriş · ' + kaynak;
      yer.appendChild(r);
    });
  }
  isle();
  new MutationObserver(isle).observe(document.body, { childList: true, subtree: true });
})();

/* Sekmeli vitrin (K-146): sekme değişince ilgili panel görünür, kaydırıcı yeniden ölçülür */
(function () {
  document.querySelectorAll('[data-tc-vitrin]').forEach(function (kap) {
    kap.querySelectorAll('[data-tc-sekme]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tc-sekme');
        kap.querySelectorAll('[data-tc-sekme]').forEach(function (b) { b.classList.toggle('is-aktif', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        kap.querySelectorAll('[data-tc-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tc-panel') !== id; });
        kap.querySelectorAll('[data-tc-panel-link]').forEach(function (l) { l.hidden = l.getAttribute('data-tc-panel-link') !== id; });
        var alan = kap.querySelector('[data-tc-panel="' + id + '"] scroll-carousel');
        if (alan) alan.scrollTo({ left: 0 });
        window.dispatchEvent(new Event('resize'));
      });
    });
  });
})();

/* Basında tomtoc (K-146): alıntılar 4 sn'de bir yukarı kayarak değişir, aktif logo renklenir; logoya tıklanınca o alıntı gelir */
(function () {
  document.querySelectorAll('[data-tc-basin]').forEach(function (kap) {
    var alintilar = kap.querySelectorAll('[data-tc-alinti]'), noktalar = kap.querySelectorAll('[data-tc-nokta]');
    if (alintilar.length < 2) return;
    var i = 0, zaman;
    function goster(n) {
      var yeni = (n + alintilar.length) % alintilar.length;
      if (yeni === i) return;
      alintilar.forEach(function (a, k) {
        a.classList.toggle('is-cikan', k === i);
        a.classList.toggle('is-aktif', k === yeni);
      });
      var eski = alintilar[i];
      setTimeout(function () { eski.classList.remove('is-cikan'); }, 600);
      i = yeni;
      noktalar.forEach(function (d, k) { d.classList.toggle('is-aktif', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function basla() { clearInterval(zaman); zaman = setInterval(function () { if (!document.hidden) goster(i + 1); }, 4000); }
    noktalar.forEach(function (d) { d.addEventListener('click', function () { goster(+d.getAttribute('data-tc-nokta')); basla(); }); });
    basla();
  });
})();

/* K-150 — renk değişiminde galeri süzmesi tarayıcıda, kaydırmadan önce.
   Tema (Impact) önce yeni kapağa kaydırıp süzmeyi sunucudan sonra uyguluyordu: kaydırıcı henüz gizli olan kapağa (beyaz ekran)
   ya da videoya kayıyordu, filtre gelince konumunu düzeltmiyordu. Burada variant:change yakalama aşamasında (temanın kendi
   dinleyicisinden önce) gizlenecek medyayı hesaplayıp uygularız; sunucudan gelen yeniden çizimden sonra kapağı yeniden seçeriz.
   Kural sunucudakiyle aynı: seçili rengin fotoğrafı yoksa süzme yapılmaz; seçili varyantın kapağı her zaman görünür. */
(function () {
  function norm(s) { return String(s || '').normalize('NFC').toLocaleLowerCase('tr').trim(); }
  // form.id kullanılmaz: formda name="id" alanı (varyant) olduğu için form.id o alanı döndürür
  function galeriBul(form) { var id = form && form.getAttribute && form.getAttribute('id'); return id ? document.querySelector('product-gallery[form="' + id + '"][data-tc-galeri]') : null; }
  function suzulecek(galeri, varyant) {
    var veri; try { veri = JSON.parse(galeri.getAttribute('data-tc-galeri')); } catch (e) { return null; }
    var secili = {};
    veri.secenekler.forEach(function (ad, i) { secili[norm(ad)] = norm(varyant.options[i]); });
    var gizle = [], eslesen = 0;
    veri.medya.forEach(function (m) {
      if (!m.o) return;
      var deger = secili[norm(m.o)];
      if (deger === undefined) return;
      if (norm(m.v) === deger) eslesen++; else gizle.push(m.p);
    });
    if (eslesen === 0) return [];
    var kapak = varyant.featured_media && varyant.featured_media.position;
    return gizle.filter(function (p) { return p !== kapak; });
  }
  function uygula(galeri, pozisyonlar, kapakSira) {
    var idx = pozisyonlar.map(function (p) { return p - 1; });
    galeri.setAttribute('filtered-indexes', JSON.stringify(pozisyonlar));
    galeri.querySelectorAll('media-carousel').forEach(function (c) { c.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: idx } })); });
    galeri.querySelectorAll('page-dots').forEach(function (d) { d.dispatchEvent(new CustomEvent('control:filter', { detail: { filteredIndexes: idx } })); });
    // seçilen rengin kapağı ve sonraki iki görseli beklemeden yüklensin (beyaz kare kalmasın)
    var medya = Array.prototype.slice.call(galeri.querySelectorAll('.product-gallery__media'));
    var basla = Math.max(0, (kapakSira || 1) - 1), sayac = 0;
    for (var i = basla; i < medya.length && sayac < 3; i++) {
      if (medya[i].hidden) continue;
      medya[i].querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.removeAttribute('loading'); });
      sayac++;
    }
  }
  function kapagaGit(galeri, varyant) {
    var sira = varyant && varyant.featured_media && varyant.featured_media.position;
    if (!sira) return;
    galeri.querySelectorAll('media-carousel').forEach(function (c) { if (typeof c.select === 'function') c.select(sira - 1, { animate: false }); });
  }
  // seçili öğe gizlendiyse (ör. seçilen boy-renk birleşimi yoksa tema varyantı boş bırakır) ilk görünen fotoğrafa geç
  function gorunureGit(galeri) {
    galeri.querySelectorAll('media-carousel').forEach(function (c) {
      var ogeler = Array.prototype.slice.call(c.querySelectorAll('.product-gallery__media'));
      var secili = c.selectedSlide;
      if (secili && !secili.hidden && secili.getAttribute('data-media-type') === 'image') return;
      var hedef = ogeler.findIndex(function (o) { return !o.hidden && o.getAttribute('data-media-type') === 'image'; });
      if (hedef < 0) hedef = ogeler.findIndex(function (o) { return !o.hidden; });
      if (hedef > -1 && typeof c.select === 'function') c.select(hedef, { animate: false });
    });
    yukle(galeri);
  }
  // seçilen boy-renk birleşimi yoksa tema varyantı boş gönderir: seçili değerleri formdaki işaretli seçeneklerden oku
  function sahteVaryant(form) {
    var id = form && form.getAttribute && form.getAttribute('id'); if (!id) return null;
    var ops = [];
    document.querySelectorAll('input[form="' + id + '"][data-option-position]:checked').forEach(function (inp) {
      // input değeri seçenek kimliği; adı etiketten al
      var etiket = document.querySelector('label[for="' + inp.id + '"]');
      var ad = etiket ? (etiket.querySelector('.sr-only') || etiket).textContent.trim() : '';
      if (ad) ops[Number(inp.getAttribute('data-option-position')) - 1] = ad;
    });
    return ops.length ? { options: ops, featured_media: null } : null;
  }
  function yukle(galeri) {
    galeri.querySelectorAll('media-carousel').forEach(function (c) {
      var s = c.selectedSlide; if (s) s.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.removeAttribute('loading'); });
    });
  }
  var sonVaryant = new WeakMap();
  // yakalama aşaması: temanın form üzerindeki dinleyicisinden önce çalışır
  document.addEventListener('variant:change', function (olay) {
    var galeri = galeriBul(olay.target); if (!galeri) return;
    var varyant = olay.detail && olay.detail.variant;
    if (!varyant) varyant = sahteVaryant(olay.target);
    sonVaryant.set(galeri, varyant || null);
    if (!varyant) return;
    var poz = suzulecek(galeri, varyant); if (!poz) return;
    uygula(galeri, poz, varyant.featured_media && varyant.featured_media.position);
  }, true);
  // sunucudan gelen yeniden çizim süzmeyi tekrar uygular; ardından kapağı yeniden seç (kaydırıcı kaymasın)
  document.addEventListener('product:rerender', function (olay) {
    var galeri = galeriBul(olay.target); if (!galeri) return;
    // tema süzmeden sonraki karelerde eski konumu geri yükleyebiliyor; düzeltmeyi onun işi bittikten sonra da tekrarla
    [0, 120, 350].forEach(function (gecikme) {
      setTimeout(function () {
        requestAnimationFrame(function () {
          var varyant = sonVaryant.get(galeri);
          if (varyant) {
            if (gecikme === 0) { var poz = suzulecek(galeri, varyant); if (poz) uygula(galeri, poz, varyant.featured_media && varyant.featured_media.position); }
            var c = galeri.querySelector('media-carousel');
            var sira = varyant.featured_media && varyant.featured_media.position;
            if (c && sira && c.selectedSlide !== c.querySelectorAll('.product-gallery__media')[sira - 1]) kapagaGit(galeri, varyant);
          }
          gorunureGit(galeri);
          yukle(galeri);
        });
      }, gecikme);
    });
  }, true);
})();

/* G7 — Judge.me sıralama etiketi (ekran okuyucu metni) İngilizce geliyor: Türkçeleştir */
(function () {
  function cevir() { document.querySelectorAll('.jdgm-sort-dropdown-label').forEach(function (l) { if (l.textContent.trim() === 'Sort by') l.textContent = 'Sırala'; }); }
  if (!document.querySelector('.jdgm-widget, #judgeme_product_reviews')) return;
  var g = new MutationObserver(cevir);
  g.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { g.disconnect(); }, 20000);
  cevir();
})();

/* K-153 — sepette adet +/−: kutudaki değeri değiştirip temanın kendi "change" akışını tetikler */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tc-adet-arti], [data-tc-adet-eksi]');
    if (!btn) return;
    var kutu = btn.closest('[data-tc-adet]'); if (!kutu) return;
    var inp = kutu.querySelector('input'); if (!inp) return;
    var adim = Number(inp.step) || 1, min = Number(inp.min) || 0, max = inp.max ? Number(inp.max) : Infinity;
    var yeni = (Number(inp.value) || 0) + (btn.hasAttribute('data-tc-adet-arti') ? adim : -adim);
    if (yeni < min) yeni = min; if (yeni > max) yeni = max;
    if (yeni === Number(inp.value)) return;
    inp.value = yeni;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* K-155 — Klaviyo yalnızca pazarlama çerezine izin verilince yüklenir (KVKK + hız).
   Klaviyo, Shopify çerez iznine yalnızca AB/İngiltere ziyaretçileri için uyuyor; Türkiye için izinsiz yükleniyordu.
   Klaviyo > Entegrasyonlar > Shopify'daki "onsite tracking" kapatılınca yükleme buradan yapılır. Sayfada zaten klaviyo.js varsa hiçbir şey yapmaz. */
(function () {
  var SITE_ID = 'RthF7y'; // Klaviyo hesabı Dossimo (Public API Key / Site ID); K-167: WxfYSY yanlış hesaptı
  function yuklu() { return !!document.querySelector('script[src*="klaviyo.com/onsite/js/"]'); }
  function yukle() {
    if (yuklu()) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/' + SITE_ID + '/klaviyo.js?company_id=' + SITE_ID;
    document.head.appendChild(s);
  }
  function kontrol() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.marketingAllowed !== 'function') return;
    // K-167: bant henüz cevaplanmamışken marketingAllowed() geçici olarak true dönebiliyor; karar verilmeden yükleme yok
    if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return;
    if (cp.marketingAllowed()) yukle();
  }
  document.addEventListener('visitorConsentCollected', function (e) { if (e.detail && e.detail.marketingAllowed) yukle(); });
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (hata) { if (!hata) kontrol(); });
  } else {
    window.addEventListener('load', kontrol);
  }
})();

/* K-169 — Hediye kampanyası: kapsamdaki ürün sepete eklenirken hediye penceresi; sepette hediye satırı bekçisi.
   Ayarlar snippets/tomtoc-hediye.liquid'den data öznitelikleriyle gelir. Hediye Shopify otomatik indirimiyle (%100) ücretsiz olur. */
(function () {
  var ayar = document.querySelector('[data-tc-hediye-ayar]');
  if (!ayar) return;
  var HEDIYE = Number(ayar.getAttribute('data-hediye-varyant'));
  var RED = 'tc_hediye_red';
  var mesgul = false;
  var kok = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  function olay(ad) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ad, {}); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: ad }); } catch (e) {}
  }
  function yenile() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
  function sepet() { return fetch(kok + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function hediyeEkle() {
    return sepet().then(function (c) {
      if (c.items.some(function (i) { return i.properties && i.properties._hediye; })) return;
      return fetch(kok + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: HEDIYE, quantity: 1, properties: { _hediye: '1' } }] }) });
    });
  }
  function degistir(key, adet) { return fetch(kok + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: adet }) }); }

  /* Sepet bekçisi: hediye var ama kapsam ürünü yok → hediyeyi çıkar; hediye adedi > 1 → 1; kapsam var, hediye yok → hatırlatma bandı */
  /* aynı satır hem gizli çekmecede hem sepet sayfasında olabilir: görünür olanı tercih et */
  function gorunur(sec) {
    var l = Array.prototype.slice.call(document.querySelectorAll(sec)).filter(function (e) { return e.offsetParent !== null; });
    if (!l.length) return document.querySelector(sec);
    var sayfada = l.filter(function (e) { return !e.closest('cart-drawer'); }); // sepet sayfasında çekmecedeki kopya değil, sayfadaki satır
    return (sayfada[0] || l[0]);
  }
  function bekci() {
    if (mesgul) return;
    var hediye = gorunur('line-item[data-tc-hediye]');
    var kapsam = gorunur('line-item[data-tc-kapsam]');
    if (hediye && !kapsam) { mesgul = true; degistir(hediye.getAttribute('data-tc-hediye'), 0).then(function () { mesgul = false; yenile(); }, function () { mesgul = false; }); return; }
    if (hediye && Number(hediye.getAttribute('data-tc-adet')) > 1) { mesgul = true; degistir(hediye.getAttribute('data-tc-hediye'), 1).then(function () { mesgul = false; yenile(); }, function () { mesgul = false; }); return; }
    var eskiBant = document.querySelector('[data-tc-hediye-bant]');
    if (kapsam && !hediye && !sessionStorage.getItem(RED)) {
      if (eskiBant) return;
      var tablo = kapsam.closest('table'); var liste = tablo ? tablo.parentElement : kapsam.parentElement; var ilk = tablo || liste.firstChild;
      var bant = document.createElement('div');
      bant.className = 'tc-hediye-bant'; bant.setAttribute('data-tc-hediye-bant', '');
      bant.innerHTML = '<span>🎁 ' + (ayar.getAttribute('data-bant') || '') + '</span><button type="button" class="tc-hediye-bant__btn" data-tc-hediye-bant-ekle>Hediyeni ekle</button>';
      liste.insertBefore(bant, ilk);
      bant.querySelector('[data-tc-hediye-bant-ekle]').addEventListener('click', function () {
        var b = this; b.setAttribute('aria-busy', 'true'); mesgul = true;
        hediyeEkle().then(function () { mesgul = false; olay('hediye_secildi'); yenile(); }, function () { mesgul = false; b.removeAttribute('aria-busy'); });
      });
    } else if (eskiBant && (hediye || !kapsam)) { eskiBant.remove(); }
  }
  var zaman = null;
  new MutationObserver(function () { clearTimeout(zaman); zaman = setTimeout(bekci, 400); }).observe(document.body, { childList: true, subtree: true });
  setTimeout(bekci, 1200);

  /* Ürün sayfası: pencere ve balon */
  var pencere = document.querySelector('.tc-hediye[data-tc-hediye]');
  if (!pencere) return;
  var balon = document.querySelector('[data-tc-hediye-balon]');
  var galeri = document.querySelector('product-gallery');
  if (balon && galeri) { galeri.prepend(balon); balon.hidden = false; }
  var varyantlar = (pencere.getAttribute('data-urun-varyantlar') || '').split(',');
  var bekleyen = null;
  function ac() { pencere.hidden = false; document.body.classList.add('tc-hediye-acik'); var b = pencere.querySelector('[data-tc-hediye-ekle]'); if (b) b.focus(); }
  function kapat() { pencere.hidden = true; document.body.classList.remove('tc-hediye-acik'); }
  function devam() { if (!bekleyen) return; var f = bekleyen; bekleyen = null; f.setAttribute('data-tc-hediye-gecti', '1'); f.requestSubmit(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || f.getAttribute('is') !== 'product-form') return;
    if (f.getAttribute('data-tc-hediye-gecti')) { f.removeAttribute('data-tc-hediye-gecti'); return; }
    var id = f.elements.id && f.elements.id.value;
    if (!id || varyantlar.indexOf(String(id)) === -1) return;
    if (sessionStorage.getItem(RED)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    bekleyen = f; ac();
  }, true);
  pencere.querySelector('[data-tc-hediye-ekle]').addEventListener('click', function () {
    var b = this; b.setAttribute('aria-busy', 'true');
    hediyeEkle().catch(function () {}).then(function () { b.removeAttribute('aria-busy'); kapat(); olay('hediye_secildi'); devam(); });
  });
  pencere.querySelectorAll('[data-tc-hediye-red]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (el.hasAttribute('data-tc-hediye-hatirla')) { try { sessionStorage.setItem(RED, '1'); } catch (e) {} olay('hediye_reddedildi'); }
      kapat(); devam();
    });
  });
  pencere.addEventListener('click', function (e) { if (e.target.hasAttribute('data-tc-hediye-perde')) { kapat(); devam(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pencere.hidden) { kapat(); devam(); } });
})();

/* K-177 — Hediye kampanyası uzatması: ilk bitiş geçince duyuru çubuğundaki ve penceredeki bitiş tarihi
   "Uzatıldı: <uzatma>'e kadar" olur. Duyuru metni tema ayarı olduğu için Liquid'le değil burada çevrilir.
   Tarihler snippets/tomtoc-hediye.liquid ayar kutusundan (data-ilk / data-son, saniye) gelir. */
(function () {
  var ayar = document.querySelector('[data-tc-hediye-ayar]');
  if (!ayar || !ayar.getAttribute('data-ilk')) return;
  var ilk = Number(ayar.getAttribute('data-ilk')) * 1000, son = Number(ayar.getAttribute('data-son')) * 1000;
  var ilkMetin = ayar.getAttribute('data-ilk-metin'), uzMetin = ayar.getAttribute('data-uzatma-metin');
  if (!(son > ilk) || !ilkMetin || !uzMetin) return;
  var eski = ilkMetin + "'e kadar", yeni = 'Uzatıldı: ' + uzMetin + "'e kadar";
  function cevir() {
    document.querySelectorAll('.announcement-bar, [data-tc-bitis-metin]').forEach(function (kok) {
      if (kok.hasAttribute('data-tc-bitis-metin')) { kok.textContent = uzMetin; return; }
      var w = document.createTreeWalker(kok, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf(eski) !== -1) n.nodeValue = n.nodeValue.split(eski).join(yeni); }
    });
  }
  var kalan = ilk - Date.now();
  if (kalan <= 0) { cevir(); window.addEventListener('load', cevir); }
  else if (kalan < 864e5) setTimeout(cevir, kalan + 1500);
})();
